// Number formatting for the Rep page. Values are Rands at cost; null means "no rows"
// (the workbook shows an empty cell there) and renders as a dash.

export const BLANK = "–"

export const fmtR = (v, decimals = 0) =>
  v == null || Number.isNaN(Number(v))
    ? BLANK
    : `R${Number(v).toLocaleString("en-US", { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}`

export const fmtShort = (v) => {
  if (v == null) return BLANK
  const n = Math.abs(v)
  const sign = v < 0 ? "-" : ""
  if (n >= 1_000_000) return `${sign}R${(n / 1_000_000).toFixed(1)}M`
  if (n >= 1_000) return `${sign}R${(n / 1_000).toFixed(0)}K`
  return `${sign}R${n.toFixed(0)}`
}

// yoy arrives as a ratio (0.054 = +5.4%); blank when LY was blank or zero.
export const fmtPct = (ratio) => {
  if (ratio == null || Number.isNaN(Number(ratio))) return BLANK
  const pct = Number(ratio) * 100
  return `${pct > 0 ? "+" : ""}${pct.toFixed(1)}%`
}

export const pctTone = (ratio, signal, neutral) => {
  if (ratio == null) return neutral[400]
  return Number(ratio) >= 0 ? signal.up : signal.down
}
